"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVolatileModel = exports.AModel = void 0;
class AModel {
    getPropertyNames() {
        return [];
    }
    getDefinedPropertyNames() {
        return [];
    }
    getPropertyValue(propertyName) {
        throw new Error(`Property ${propertyName} not recognized`);
    }
    isPropertyDefined(propertyName) {
        return false;
    }
    isAnyPropertyDefined() {
        return false;
    }
    toJson() {
        return {};
    }
    write(protocol) {
    }
}
exports.AModel = AModel;
class AVolatileModel extends AModel {
    read(protocol, modelHeader) {
        for (let a = 0; a < modelHeader.propertyCount; a++) {
            const propertyHeader = protocol.readModelPropertyHeader();
            if (!this.readProperty(protocol, propertyHeader))
                throw new Error(`Property ${propertyHeader.propertyName} not recognized`);
        }
    }
    readProperty(protocol, propertyHeader) {
        return false;
    }
}
exports.AVolatileModel = AVolatileModel;
